import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import _ from "lodash";
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import {formatMoney} from "accounting-js";
import AmountsAdd from './../../elements/agencies/widget/amounts_add';
import AmountsSearch from "../../elements/agencies/widget/amounts_search";

class AgenciesAmounts extends Component {
	render(){
		return(
			<AgenciesAmountsList {...this.props}/>
		);
	}

	componentWillMount(){
		const { amounts_agencies } = this.props;
		this.props.amountsAgenciesShow(amounts_agencies.pages.current, amounts_agencies.filters);
	}
}

export class AgenciesAmountsList extends Component{
	render() {
		const { amounts_agencies } = this.props;
		let au = _.find(amounts_agencies.permissions, (o) => o === 'Update');
		let ad = _.find(amounts_agencies.permissions, (o) => o === 'Delete');
		return (
			<div>
				{amounts_agencies.isFetching ? <Loading/> :
					[<table className={`inm-table`} key="amounts-agencies-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>Instancia</th>
							{/*<th>Modalidad</th>*/}
							<th>Version</th>
							<th>Monto Maximo</th>
						</tr>
						</thead>
						<tbody>
						{_.map(_.orderBy(amounts_agencies.list, ['id']), (row, k) => {
							return (
								<tr key={k}>
									<td style={{width: 10 + '%'}}>
										<div className="actions">
											{au ? <NavLink to={`/instancias/montos/editar/${row.id}`}>
												<i className="fa fa-edit"></i></NavLink>:''}
											{ad ? <button onClick={() => this._getConfirm(row.id)}>
												<i className="fa fa-trash-o"></i></button> : ''}
										</div>
										{row.id}
									</td>
									<td>{row.state ? row.state.name:'---'}</td>
									{/*<td>{row.modality.name}</td>*/}
									<td><strong>{row.version.name}</strong></td>
									<td>{formatMoney(row.amount_max)}</td>
								</tr>
							)
						})}
						</tbody>
					</table>,
						amounts_agencies.pages.total > 20 &&
						<InmPagination key="amounts-agencies-pages"
						               current={amounts_agencies.pages.current}
						               total={amounts_agencies.pages.total}
						               nextPage={this._handlePageChange}
						/>
					]}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el monto?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.amountAgencyDelete(id)
		})
	}

	_handlePageChange(value) {
		const { amounts_agencies } = this.props;
		this.props.amountsAgenciesShow(value, amounts_agencies.filters);
	}
}

export default BaseLayout(AgenciesAmounts, {
	title: `Administrar Montos de las instancias`,
	subnav: {
		icon: 'fa fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <AmountsSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AmountsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/amounts_agencies/index.jsx